/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Clear_DefaultInputs */

const cs_templates_clear_default = /** @type {(inputs: Templates_Clear_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit výchozí`)
};

const en_templates_clear_default = /** @type {(inputs: Templates_Clear_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear default`)
};

/**
* | output |
* | --- |
* | "Clear default" |
*
* @param {Templates_Clear_DefaultInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_clear_default = /** @type {((inputs?: Templates_Clear_DefaultInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Clear_DefaultInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_clear_default(inputs)
	return cs_templates_clear_default(inputs)
});